module.exports = __webpack_public_path__ + "static/irvine-john-ocean.5e19ee30.jpg";